// extracted by css-extract-rspack-plugin
export default {"products-sold":"KZ03js","productsSold":"KZ03js"};